
$(document).on('turbolinks:load', function() {
  console.log("turbolinks:load")
  $('#loading').hide();
  // var elem = $("img");

  // if (!elem.prop('complete')) {
  //   console.log("Waiting to be loaded!");
  //   elem.on('load', function() {
  //     console.log("Loaded!");
  //     console.log(this.complete);
  //   });
  // } else {
  //   console.log("Already loaded!");
  // }
});


$(document).on('turbolinks:before-visit', function() {
  // your code
  console.log("turbolinks:before-visit")
});

$(document).on('turbolinks:render', function() {
  // your code
  console.log("turbolinks:render")
});

$(document).on('turbolinks:before-render', function() {
  // your code
  console.log("turbolinks:before-render")
});

$(document).on('turbolinks:request-end', function() {
  // your code

  console.log("turbolinks:request-end")
});

$(document).on('turbolinks:request-start', function() {
  // your code
  console.log("turbolinks:request-start")
});



$(document).on('turbolinks:visit', function() {
  // your code
  console.log("turbolinks:visit")
});
$(document).on('before-visit', function() {
  // your code
  console.log("before-visit")
});
$(document).on('turbolinks:click', function() {
  // your code

  $('#loading').show();
  console.log("turbolinks:click")
});


// function initializeProductSliders() {
//   $("[class^='product-slider-']").each(function () {
//     const $slider = $(this);
//     const productId = $slider.attr('class').match(/product-slider-(\d+)/)?.[1];
//     if (!productId) return;

//     const $loading = $(".loading_component-" + productId);
//     $loading.addClass("loading_component_image");

//     loadjs([
//       "/assets/frontend/lib/slick-theme.css",
//       "/assets/frontend/lib/slick.css",
//       "/assets/frontend/lib/slick.min.js"
//     ], 'products_slider', {
//       async: false
//     });

//     loadjs.ready('products_slider', function () {
//       $loading.removeClass("loading_component_image");

//       if (!$slider.hasClass('slick-initialized')) {
//         $slider.slick({
//           autoplay: false,
//           dots: true,
//           arrows: true,
//           lazyLoad: "ondemand",
//           slidesToShow: 1
//         });
//       }
//     });
//   });
// }
